import Content from "./partials/Content";
import Footer from "./partials/Footer";
import Modal from "./Modal";

Modal.Footer = Footer;
Modal.Content = Content;
export default Modal;
